import { api } from "@/services/api";
import { User } from "../user/models";

export async function getProfile(abortSignal?: AbortSignal): Promise<User> {
  const response = await api.get<User>("/me", { signal: abortSignal });
  return response.data;
}

export async function changePassword({
  currentPassword,
  newPassword,
}: {
  currentPassword: string;
  newPassword: string;
}): Promise<User> {
  const response = await api.patch<User>("/me/password", {
    currentPassword,
    password: newPassword,
  });
  return response.data;
}

export async function updateProfile({ name }: { name: string }): Promise<User> {
  const response = await api.patch<User>("/me", { name });
  return response.data;
}

export async function updateAvailability({ isAvailable }: { isAvailable: boolean }): Promise<void> {
  await api.patch("/me/availability", { isAvailable });
}

export async function updateNotificationFlags({
  sendEmailNotices,
  sendEmailConsumption,
}: {
  sendEmailNotices: boolean;
  sendEmailConsumption: boolean;
}): Promise<User> {
  const response = await api.patch<User>("/me", {
    sendEmailNotices,
    sendEmailConsumption,
  });
  return response.data;
}
